const RenderPoemLine = ({ item, searchkey, onTagClick }) => {
  const lowerSearchKey = searchkey?.toLowerCase()?.trim();
  
  const highlightLine = (line, offset = 0) => {
    if (!line) return null;
    const lowerLine = line.toLowerCase();
    const result = [];
    let i = 0;
    
    // Prepare all tags and sort by length (longest first)
    const allTags = [];
    if (item.tags?.length) {
      for (const tagObj of item.tags) {
        if (tagObj?.namesList?.length) {
          for (const tag of tagObj.namesList) {
            if (tag && tag.trim()) {
              allTags.push({
                text: tag.trim(),
                lowerText: tag.trim().toLowerCase(),
                tagObj: tagObj
              });
            }
          }
        }
      }
      // Sort by length descending to prioritize longer matches
      allTags.sort((a, b) => b.text.length - a.text.length);
    }
    
    while (i < line.length) {
      let matched = false;
      
      // PRIORITY 1: Match tags first (case-insensitive)
      for (const tag of allTags) {
        if (lowerLine.startsWith(tag.lowerText, i)) {
          result.push(
            <span
              key={`tag-${offset + i}`}
              className="__tagged"
              onClick={() => onTagClick(item?.tags)}
            >
              {line.substr(i, tag.text.length)}
            </span>
          );
          i += tag.text.length;
          matched = true;
          break;
        }
      }
      
      // PRIORITY 2: Match search key (only if no tag matched)
      if (!matched && lowerSearchKey && lowerLine.startsWith(lowerSearchKey, i)) {
        // Check if this search match overlaps with any tag
        let overlapsWithTag = false;
        for (const tag of allTags) {
          const searchEnd = i + lowerSearchKey.length;
          const tagStart = lowerLine.indexOf(tag.lowerText, i);
          if (tagStart !== -1 && tagStart < searchEnd && tagStart + tag.text.length > i) {
            overlapsWithTag = true;
            break;
          }
        }
        
        if (!overlapsWithTag) {
          result.push(
            <span
              key={`search-${offset + i}`}
              className="highlighter"
            >
              {line.substr(i, lowerSearchKey.length)}
            </span>
          );
          i += lowerSearchKey.length;
          matched = true;
        }
      }
      
      // PRIORITY 3: Collect consecutive non-tagged characters
      if (!matched) {
        let plainText = '';
        const startIndex = i;
        
        // Collect all consecutive characters that don't start a tag or search match
        while (i < line.length) {
          let willMatch = false;
          
          // Check if current position starts a tag
          for (const tag of allTags) {
            if (lowerLine.startsWith(tag.lowerText, i)) {
              willMatch = true;
              break;
            }
          }
          
          // Check if current position starts a search match
          if (!willMatch && lowerSearchKey && lowerLine.startsWith(lowerSearchKey, i)) {
            willMatch = true;
          }
          
          if (willMatch) break;
          
          plainText += line[i];
          i++;
        }
        
        if (plainText) {
          result.push(<span key={`text-${offset + startIndex}`}>{plainText}</span>);
        }
      }
    }
    
    return result;
  };
  
  return (
    <p className="__common_para">
      {highlightLine(item.line1, 0)}
      <br />
      {highlightLine(item.line2, (item.line1?.length || 0) + 1)}
    </p>
  );
};

export default RenderPoemLine;